const getSeasonLabel = (text, t, keyBase) => {
  if (!t || typeof t !== "function") return "";
  const value = typeof text === "string" ? text : "";
  const textLen = value.length;
  let data = "";

  if (textLen % 2 !== 0) {
    const start = (textLen - 1) / 2;
    data = value.slice(start, start + 1);
  } else {
    const start = textLen / 2 - 1;
    data = value.slice(start, start + 2);
  }

  if (data === "S") {
    return t(`${keyBase}.summer`);
  } else if (data === "W") {
    return t(`${keyBase}.winter`);
  }
  return t(`${keyBase}.all`);
};

export default getSeasonLabel;
